import SaleTemplateDatalist from "components/entities/templates/agriculture/sale/SaleTemplateDatalist";
import { AppRoutes } from "config/router";

const SaleNewItemModal = () => {
    return (
        <SaleTemplateDatalist
            newUrl={AppRoutes.AGRICULTURE_SALE_FORM}
            onClickUrl={i => `${AppRoutes.AGRICULTURE_SALE_FORM}?template=${i?.id}`}
        />
    );
};

export default SaleNewItemModal;
